import React, { useState } from 'react'
import { currency } from './inventoryData';
import { StatCard } from './InventoryShared';

function ItemDetailsPage({ item }) {
    const [tab, setTab] = useState('Purchase');
    const tabRows = {
        Purchase: [`${item.lastPurchase.qty} | ${currency.format(item.lastPurchase.amount)} | ${item.lastPurchase.date}`],
        Usage: [`Used Today: ${item.usedToday} ${item.unit}`, `Weekly average: 9 ${item.unit}`],
        Logs: ['Stock adjusted by Store Manager', 'Low stock threshold reviewed'],
    };

    return (
        <div className='inventory-details-page'>
            <section className='inventory-panel inventory-details-header'>
                <div className='inventory-item-avatar'>{item.image}</div>
                <div>
                    <h3>{item.name}</h3>
                    <p>{item.type} • Unit: {item.unit}</p>
                </div>
            </section>
            <div className='inventory-stat-grid'>
                <StatCard title='Opening Stock' value={`${item.openingStock} ${item.unit}`} note='Start balance' />
                <StatCard title='Current Stock' value={`${item.currentStock} ${item.unit}`} note={item.status} />
                <StatCard title='Used Today' value={`${item.usedToday} ${item.unit}`} note='Auto / manual usage' />
                <StatCard title='Wastage' value={`${item.wastage} ${item.unit}`} note='Reported loss' />
            </div>
            <section className='inventory-panel'>
                <div className='inventory-filter-tabs no-border'>
                    {Object.keys(tabRows).map(item => <button key={item} className={tab === item ? 'active' : ''} onClick={() => setTab(item)}>{item}</button>)}
                </div>
                <div className='inventory-log-list'>
                    {tabRows[tab].map(row => <div key={row}>{row}</div>)}
                </div>
                <div className='inventory-actions sticky'>
                    <button>Update Stock</button>
                    <button>Add Purchase</button>
                </div>
            </section>
        </div>
    );
}

export default ItemDetailsPage
